import { useState } from "react";
import axiosService from "../axios";
import { AxiosResponse, AxiosError } from "axios";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";

//put else where as needed elsewhere
interface BasicResponseModel {
    successfulRequest: boolean;
    errorMessage: string;
    warningMessage: string;
}

const useCheckRepPin = () => {
    const user = useSelector((state: ApplicationState) => state.oidc.user);
    const [pinCheckIsProcessing, setPinCheckIsProcessing] = useState(false);
    const [requestEndedWithError, setRequestEndedWithError] = useState(false);
    // const [requestHasWarning, setRequestHasWarning] = useState(false);
    const [pinCheckMatched, setPinCheckMatched] = useState(false);

    const postCheckPinNumber = async (enteredPinNumber: string) => {
        setPinCheckIsProcessing(true);
        setRequestEndedWithError(false);
        setPinCheckMatched(false);

        try {
            // Submit the Order Lines to API
            await axiosService
              .post(
                    `api/v1/RepUser/CheckRepUserPinEntered`,  
                    {
                        email: user.profile.email,
                        enteredPin: enteredPinNumber
                    })
                .then((response: AxiosResponse<BasicResponseModel>) => {
                    const { data } = response;
                    setPinCheckMatched(data.successfulRequest);
                    if(data.errorMessage && data.errorMessage !== ''){
                        setRequestEndedWithError(true);
                    }
                    setPinCheckIsProcessing(false);

                    // checkCancelProcessing(data);
                })
                .catch((error: AxiosError) => {
                    console.log(error.message);
                    setRequestEndedWithError(true);
                    setPinCheckIsProcessing(false);
                });
        } catch (error : any) {
            console.log(error.message);
            setRequestEndedWithError(true);
            setPinCheckIsProcessing(false);
        }

    }

    return {postCheckPinNumber, pinCheckIsProcessing, requestEndedWithError, pinCheckMatched }
};

export default useCheckRepPin;